var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypescript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#3178c6",
    height: 64,
    rx: 6.25,
    width: 64,
    x: 0,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M39.617 50.928v6.258c1.017.521 2.22.912 3.609 1.173 1.389.26 2.853.391 4.392.391 1.5 0 2.925-.143 4.274-.43 1.35-.287 2.534-.759 3.551-1.418 1.017-.658 1.822-1.518 2.416-2.581.594-1.063.891-2.377.891-3.941 0-1.134-.17-2.128-.509-2.982-.339-.854-.828-1.613-1.467-2.278-.639-.665-1.405-1.262-2.299-1.79-.893-.528-1.9-1.027-3.022-1.496-.822-.339-1.559-.668-2.211-.987-.652-.32-1.304-.639-1.859-.965-.456-.332-.808-.684-1.056-1.056-.248-.372-.372-.792-.372-1.261 0-.43.111-.818.333-1.164.221-.345.535-.642.939-.889.404-.248.9-.44 1.487-.577.587-.136 1.239-.205 1.956-.205.522 0 1.073.039 1.653.117.58.078 1.164.199 1.751.362.587.163 1.157.368 1.712.616.554.247 1.066.534 1.536.86v-5.847c-.554-.26-1.094-.53-1.622-.706-.528-.176-1.123-.352-1.783-.528-.66-.176-1.383-.286-2.169-.33-.786-.043-1.631-.064-2.537-.064-1.487 0-2.895.16-4.226.479-1.33.319-2.5.818-3.512 1.496-1.01.678-1.809 1.542-2.396 2.591-.587 1.05-.88 2.304-.88 3.764 0 1.864.538 3.455 1.614 4.772 1.076 1.316 2.709 2.431 4.901 3.344.86.352 1.662.697 2.406 1.036.743.339 1.386.691 1.927 1.056.541.365.968.763 1.281 1.193.313.43.47.919.47 1.467 0 .404-.098.779-.294 1.124-.195.345-.492.645-.89.9-.398.254-.893.453-1.487.596-.593.144-1.287.216-2.084.216-1.356 0-2.7-.238-4.03-.714-1.33-.476-2.562-1.19-3.697-2.142zM29.097 35.51H37.125V30.375H14.75v5.135h7.988V58.375h6.359V35.51z",
    fill: "#ffffff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.a3cb9f3108ba4c9cc1e0cbebc67562c7.svg";
export { ForwardRef as ReactComponent };